const icons = {
  water: 'mdi-water',
  soil: 'mdi-shovel',
  dustfall: 'mdi-weather-windy',
  plant: 'mdi-flower',
  'drinking water': 'mdi-water-pump',
}

export function getMediaTypeIcon(mediaType) {
  const defaultIcon = 'help'
  if (!mediaType) return defaultIcon
  let normalizedType = mediaType.split(' ')[0].toLowerCase()
  let icon = icons[normalizedType]

  if (icon) return icon
  return defaultIcon
}